import script from "./GetPowerDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./GetPowerDialog.vue?vue&type=script&setup=true&lang=js"

import "./GetPowerDialog.vue?vue&type=style&index=0&id=26e3afe8&scoped=true&lang=css"

import exportComponent from "D:\\_A-Project\\KoManga\\Ko-Manga-Center-Ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26e3afe8"]])

export default __exports__